import { render } from "./EditRequest3.vue?vue&type=template&id=b0baaaca"
import script from "./EditRequest3.vue?vue&type=script&lang=js"
export * from "./EditRequest3.vue?vue&type=script&lang=js"

import "./EditRequest3.vue?vue&type=style&index=0&id=b0baaaca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__